import BaseComponent from "../../../baseComponent.js";
import GaugeWidget from "../../widgets/gauge/gaugeWidget.jsx";

export default class Gauge extends BaseComponent {
  constructor(props) {
    super(props);
  }

  render() {
    let component;
    for (let componentId in this.props.components) {
      component = this.props.components[componentId];
    }
    return (
      <GaugeWidget widget={this.props.widget}
                   widgetId={this.props.model.id}
                   legends={this.props.model.legends}
                   max={this.props.model.legends[0].parameters.max}
                   isAddWidget={true}
                   togglePreloader={() => true}
                   componentId={component.controller.id}/>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/dashboard/add-widget/widgets/gauge.jsx